import React from "react";
import PropTypes from "prop-types";
import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Switch from '@material-ui/core/Switch';
import classNames from "classnames";

const theme = createMuiTheme({
  typography: {
    fontWeight: 400,
    lineHeight: 1.5,
    letterSpacing: '.5px',
    fontFamily: ['"Open Sans"', 'Arial'].join(',')
  }
});

export const CustomSwitch = withStyles(theme => ({
  root: {
    width: 28,
    height: 16,
    padding: 0,
    display: 'flex'
  },
  switchBase: {
    padding: 2,
    color: theme.palette.grey[500],
    '&$checked': {
      transform: 'translateX(12px)',
      color: theme.palette.common.white,
      '& + $track': {
        opacity: 1,
        backgroundColor: '#00ACF1',
        borderColor: '#00ACF1'
      }
    }
  },
  thumb: {
    width: 12,
    height: 12,
    boxShadow: 'none'
  },
  track: {
    border: `1px solid ${theme.palette.grey[500]}`,
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: theme.palette.common.white
  },
  checked: {}
}))(Switch);

export default class Toggle extends React.Component {
  static propTypes = {
    /**
     * the function to execute when toggling the toggled state
     */
    onClick: PropTypes.func,
    /**
     * the value to populate the initial toggle state
     */
    initialToggle: PropTypes.bool,
    /**
     * the value to add a clickable label on the left
     */
    leftLabel: PropTypes.string,
    /**
     * the value to add a clickable label on the right
     */
    rightLabel: PropTypes.string,
    /**
     * Any additional classes to add to icon element.
     */
    className: PropTypes.string
  };

  static defaultProps = {
    onClick: () => {},
    initialToggle: false
  };

  constructor(props) {
    super(props);

    this.state = {
      toggled: props.initialToggle
    };
  }

  toggle = () => {
    this.props.onClick(!this.state.toggled);
    this.setState(state => ({ toggled: !state.toggled }));
  };

  render() {
    const { toggled } = this.state;
    return (
      <ThemeProvider theme={theme}>
        <Typography component="div">
          <Grid component="label" container alignItems="center" className={classNames(this.props.className, "mb-0")}>
            {this.props.leftLabel && <Grid item className="mr-2">{this.props.leftLabel}</Grid>}
            <Grid item>
              <CustomSwitch checked={toggled} onChange={this.toggle}/>
            </Grid>
            {this.props.rightLabel && <Grid item className="ml-2">{this.props.rightLabel}</Grid>}
          </Grid>
        </Typography>
      </ThemeProvider>
    );
  }
}
